<template>
  <div>
    <b-alert variant="secondary" show>
      <b-row cols="12" class="mb-1 alert-heading w-100">
        <b-col class="w-100">
          <Filters
            :showFilters="true"
            :hideRight="true"
            :hideLanguage="true"
            :hideStatus="true"
            :initialFilters="initialFilters"
            @downloadCSV="downloadCSV"
            @submitFilter="filterSubmitted"
            @resetFilter="resetFilter"
            @getAllExpense="showDeletedChanged"
          />
        </b-col>
      </b-row>
    </b-alert>
    
    <div>
      <b-row>
        <b-col
          class="d-flex align-items-end justify-content-end justify-content-sm-end"
        >
        </b-col>
      </b-row>
    </div>

    <b-card no-body>
      <b-table
        bordered
        v-if="$can('read', 'expense')"
        :fields="fields"
        :items="expenseList"
        empty-text="No matching records found"
        show-empty
        responsive
        small
        hover
      >
        <template #head(sr)="data">
          <b-badge v-if="pagination.total" variant="success">{{
            pagination.total
          }}</b-badge>
        </template>
        <template #cell(additionalData)="data">
          <div style="display: flex;justify-content: center;align-items: center;">
                  <feather-icon
                    style="cursor: pointer"
                    icon="InfoIcon"
                    size="23"
                    @mouseenter="handleHoverId(data.item.revenue_expense_id)"
                    @mouseleave="handleHoverRelease()"
                  />
                </div>
          <div v-if="hoverId === data.item.revenue_expense_id">
          <hover-metadata-component
            :item="{
              ...data.item,
              createdAt: formatDate(data.item.createdAt),
              updatedAt: formatDate(data.item.updatedAt),
            }"
            :idField="'revenue_expense_id'"
            :createdAt="data.item.createdAt"
            :createdBy="data.item.createdBy_name"
            :updatedAt="data.item.updatedAt"
            :updatedBy="data.item.updatedBy_name"
            :isHovered="hoverId === data.item.revenue_expense_id"
            :showAbove="data.index >= itemsInRow - 3? true : false "
          />
        </div>
        </template>
        <template #cell(sr)="data">
          {{
            data.index + 1 + (pagination.currentPage - 1) * pagination.perPage
          }}
        </template>

        <template #cell(expense_type)="data">
          {{
            data.value == 1
              ? "MG PAID"
              : data.value == 2
              ? "BUMPER PAID"
              : data.value == 3
              ? "OVERAGES PAID"
              : data.value == 4
              ? "DIVERS PAID"
              : data.value == 5
              ? "P&A Expense"
              : data.value == 6
              ? "Less Licensor corridor Paid"
              : data.item.revenueType
          }}
        </template>
        <template #cell(expense_amount)="data">
          <b-form-input
            v-if="data.item.status == '100'"
            id="from"
            v-model="data.item.expense_amount"
            placeholder="Expense Amount"
            type="number"
          />
          <div v-else class="text-nowrap">
            <b>
              <!-- <span style="text-align: left">CHF</span> -->
              <span>{{
                data.value ? formatCurrency(data.value) : "0.00"
              }}</span></b
            >
          </div>
        </template>
        <template #cell(comment)="data">
          <b-form-input
            v-if="data.item.status == '100'"
            id="from"
            v-model="data.item.comment"
            placeholder="Comment"
            type="text"
          />
          <div v-else class="text-nowrap">
            <b>
              <!-- <span style="text-align: left">CHF</span> -->
              <span>{{
                data.value ? data.value : ""
              }}</span></b
            >
          </div>
        </template>
        <template #cell(expense_date)="data">
          <flat-pickr
            v-if="data.item.status == '100'"
            :config="{
              ...$flatPickrConfig,
            }"
            placeholder="Revenue Date"
            class="form-control"
            v-model="data.item.expense_date"
          />

          <span v-else>{{
            data.value ? moment(data.value).format("DD/MM/YYYY") : ""
          }}</span>
        </template>

        <template #cell(action)="data">
          <div class="text-nowrap">
            <b-badge
              v-if="$can('update', 'expense')"
              type="submit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              size="sm"
              class="mr-1"
              pill
              :variant="
                showDeletedRevenues
                  ? 'light-danger'
                  : data.item.status == '100'
                  ? 'light-warning'
                  : 'light-success'
              "
              @click="
                enableEdit(
                  data.item,
                  data.item.status == '100' ? 'save' : 'edit'
                )
              "
            >
              {{ data.item.status == "100" ? "Save" : "Edit" }}
            </b-badge>
            <b-badge
              v-if="data.item.status == '100'"
              type="submit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              size="sm"
              class="mr-1"
              pill
              :variant="
                showDeletedRevenues
                  ? 'light-danger'
                  : data.item.status == '100'
                  ? 'light-success'
                  : 'light-warning'
              "
              @click="enableEdit(data.item, 'cancel')"
            >
              Cancel
            </b-badge>
            
              <b-badge
                v-if="showDeletedRevenues"
                type="submit"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                pill
                variant="light-danger"
                @click="
                  () => {
                    showModal('Are you sure want to revert?', 'save').then((value) => {
                      if (value) {
                        handle_revert(data.item);
                      }
                    });
                  }
                "
              >
                Revert
              </b-badge>
              <b-badge
              v-else-if="$can('delete', 'expense') && data.item.status != '100'"
              type="submit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              size="sm"
              pill
              variant="light-success"
              @click="showDeleteConfirm(data.item)"
            >
              Delete
            </b-badge>
          </div>
        </template>
      </b-table>
      <template #footer>
        <div>
          <b-row>
            <b-col
              class="d-flex align-items-end justify-content-end justify-content-sm-center"
            >
              <b-pagination
                v-model="pagination.currentPage"
                :total-rows="pagination.total"
                :per-page="pagination.perPage"
                @change="onChange"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
                :limit="15"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BProgress,
  BBadge,
  BButton,
  BTooltip,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormInput,
  BAlert,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { GetExpenseData, DeleteExpense } from "@/apiServices/RevenueServies";
import vSelect from "vue-select";
import moment from "moment";
import Filters from "../../../components/Filters.vue";
import { downloadFromURL } from "@/utils/helpers";
import ToastificationContentVue from "@core/components/toastification/ToastificationContent.vue";
import flatPickr from "vue-flatpickr-component";
import { formatCurrency } from "@/utils/helpers";
import { TokenService } from "@/apiServices/storageService";
import HoverMetadataComponent from "@/views/components/HoverMetadataComponent.vue";
import * as RevenueServices from "@/apiServices/RevenueServies";
import showModal from "../../../components/ModalConfirmation";


export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BTable,
    BProgress,
    BBadge,
    vSelect,
    BButton,
    BTooltip,
    BPagination,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    Filters,
    ToastificationContentVue,
    flatPickr,
    BFormInput,
    BAlert,
    HoverMetadataComponent,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      moment: moment,
      hoverId: null,
      BASE_URL: process.env.VUE_APP_BASEURL,
      moment: moment,
      pagination: {
        currentPage: 1,
        perPage: 25,
        totalRows: 1,
        total: 0,
        perPageOptions: [25, 50, 100],
      },
      fields: [
        { key: "sr", label: "SR", class: "text-center" },
        { key: "company", label: "Licensor", class: "text-left" },

        { key: "movie_unique", label: "Movie UniqueID", class: "text-right" },
        { key: "movie_title", label: "Movie", class: "text-left" },
        // { key: "territory_name", label: "Territory" },
        { key: "expense_type", label: "Expense Type", class: "text-left" },
        { key: "territoryParentName", label: "Territory", class: "text-left" },
        // { key: "vatCode", label: "Accounting Code"},
        { key: "expense_date", label: "Date", class: "text-center" },
        {
          key: "expense_amount",
          label: "Amount(CHF)",
          class: "text-right",
          variant: "danger",
        },
        { key: "comment", label: "Comment", class: "text-left" },
        // { key: "action", class: "text-center", label: "Action" },
        // {
        //   key: "additionalData",
        //   label: "Logs",
        // },
      ],

      filters: {},
      initialFilters: null,

      expenseList: [],
      showDeletedRevenues: false,
      itemsInRow: 25,
    };
  },

  mounted() {
    this.getAllExpense();
  },
  beforeMount() {
    this.updateColumns();
    const q = this.$route && this.$route.query ? this.$route.query : {};
    if (q.start_date || q.end_date) {
      const range = `${q.start_date || ""} to ${q.end_date || ""}`;
      this.filters = { date_range: range };
      this.initialFilters = { date_range: range };
    }
  },
  methods: {
    showModal,
    showDeletedChanged(show){
      console.log({show})
      this.showDeletedRevenues = show;
      this.getAllExpense();
    },
    formatDate(dateString) {
      // console.log(dateString);
      if (!dateString) return "";
      if (
        dateString.startsWith("0000-00-00") ||
        !moment(dateString).isValid()
      ) {
        return "";
      } else {
        let val = moment(dateString).format("DD-MM-YYYY");
        // console.log(val, "after-conversion");
        return val;
      }
    },
    handleHoverId(hovereringId) {
      // console.log(hovereringId, "hoverId");
      this.hoverId = hovereringId;
    },
    handleHoverRelease() {
      this.hoverId = null;
    },
    formatCurrency,
    downloadCSV() {
      try {
        const token = TokenService.getToken();

        if (!token) {
          alert("Error in getting token");
        }
        let payload = {
          search: this.search,
          limit: this.pagination.perPage,
          page: this.pagination.currentPage,
        };

        if (this.filters) {
          payload = {
            ...payload,
            movie_id: this.filters.movie ? this.filters.movie.movie_id : "",
            vendor_id: this.filters.vendor ? this.filters.vendor.vendor_id : "",
            territory_id: this.filters.territory
              ? this.filters.territory.lbl_id
              : "",
            start_date: this.filters.date_range
              ? this.filters.date_range.split(" to ")[0]
              : "",
            end_date: this.filters.date_range
              ? this.filters.date_range.split(" to ")[1]
              : "",
          };
        }

        let baseURL = `${process.env.VUE_APP_BASEURL}/revenue/sheet/download-expenses?authorization=${token}`;

        const urlStr = this.getURLString(baseURL, payload);

        downloadFromURL(urlStr, "Expenses", "csv");
      } catch (error) {
        console.error(`Error in downloadCSV `, error);
      }
    },
    getURLString(baseURL, payload) {
      let urlKeyValuePairs = [];

      for (let key in payload) {
        urlKeyValuePairs.push(`${key}=${payload[key]}`);
      }

      return baseURL + "&" + urlKeyValuePairs.join("&");
    },
    async getAllExpense() {
      try {
        let payload = {
          search: this.search,
          limit: this.pagination.perPage,
          page: this.pagination.currentPage,
        };
        if (this.filters) {
          // console.log(this.filters, "fil");
          //return;
          payload = {
            ...payload,
            movie_id: this.filters.movie ? this.filters.movie : "",
            vendor_id: this.filters.vendor ? this.filters.vendor.vendor_id : "",
            territory_id: this.filters.territory
              ? this.filters.territory.lbl_id
              : "",
            start_date: this.filters.date_range
              ? this.filters.date_range.split(" to ")[0]
              : "",
            end_date: this.filters.date_range
              ? this.filters.date_range.split(" to ")[1]
              : "",
              show_deleted: this.showDeletedRevenues,
          };
        }
        const response = await GetExpenseData(payload);
        if (response.data.status) {
          this.expenseList = response.data.data.data;
          this.itemsInRow = this.expenseList.length;
          if (this.pagination.currentPage == 1) {
            this.pagination.total = response.data.data.pagination.total;
          }
        }
      } catch (err) {
        console.log("Error in getting expense list ", err);
      }
    },
    async deleteExpense(data, type) {
      const response = await DeleteExpense({
        data: data,
        type: type,
      });
      if (response.data.status) {
        this.getAllExpense();
        return this.$toast({
          component: ToastificationContentVue,
          props: {
            title: response.data.message || "Deleted Successfully",
            icon: "EditIcon",
            variant: "success",
          },
        });
      }
      return this.$toast({
        component: ToastificationContentVue,
        props: {
          title: response.data.message || "Delete Failed",
          icon: "EditIcon",
          variant: "danger",
        },
      });
    },

    showDeleteConfirm(data) {
      this.$bvModal
        .msgBoxConfirm("Are you sure, you want to delete?", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) this.deleteExpense(data, 0);
        })
        .catch((err) => {
          // An error occurred
        });
    },
    showSaveConfirm(data) {
      this.$bvModal
        .msgBoxConfirm("Are you sure, you want to save?", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          cancelVariant:"outline-success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) this.deleteExpense(data, 1);
        })
        .catch((err) => {
          // An error occurred
          console.error(err)
        });
    },
    enableEdit(data, type) {
      if (type == "save") {
        this.showSaveConfirm(data)
        // this.deleteExpense(data, 1);
      } else if (type == "cancel") {
        let getIndex = this.expenseList.findIndex(
          (x) => x.revenue_expense_id == data.revenue_expense_id
        );
        this.getAllExpense()
        if (getIndex >= 0) {
          this.expenseList[getIndex].status = 1;
        }
      } else {
        let getIndex = this.expenseList.findIndex(
          (x) => x.revenue_expense_id == data.revenue_expense_id
        );
        if (getIndex >= 0) {
          this.expenseList[getIndex].status = 100;
        }
      }
    },

    filterSubmitted(filters) {
      this.filters = filters;
      this.pagination.currentPage = 1;
      this.onChange();
    },
    resetFilter() {
      this.filters = {};
      this.pagination.currentPage = 1;
      this.onChange();
    },
    onChange() {
      this.$nextTick(() => {
        this.getAllExpense();
      });
    },


    async handle_revert(data) {
        // console.log(data, "data in handle_revert");
        try {
          // console.log("Reverting item:", data);
          let response;

          if (!data || typeof data !== "object") {
            console.warn("Invalid data object passed to handle_revert");
            return;
          }

          if (data.revenue_data_id) {
            const { revenue_data_id } = data;

            const payload = { revenue_data_id };
            response = await RevenueServices.revert_revenue(payload);

          } else {
            const { revenue_expense_id } = data;
            if (!revenue_expense_id) {
              console.warn("Missing revenue_expense_id");
              return;
            }

            const payload = { revenue_expense_id };
            response = await RevenueServices.revert_expense(payload);
          }

          if (response?.data?.status) {
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title: response.data.message || "Success",
                icon: "EditIcon",
                variant: "success",
              },
            });
            this.$emit("modal-cancel");
            this.getAllExpense();
          } else {
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title: "Migration failed: " + (response?.data?.message || "Unknown error"),
                icon: "EditIcon",
                variant: "danger",
              },
            });
          }
        } catch (error) {
          console.error("Error during Reverting Revenue:", error);
        }
      },
    updateColumns() {
      let fieldsColumn = [];
      if(
        this.$can('update', 'expense') ||
        this.$can('delete', 'expense')
      ) {
        fieldsColumn.push({ key: "action", class: "text-center", label: "Action" })
      }
      fieldsColumn.push({
          key: "additionalData",
          label: "Logs",
      })
      this.fields = [...this.fields, ...fieldsColumn];
    }




  },
};
</script>
<style scoped lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
